import ReportIcon from "../svg/LandingReportIcon.svg"
const Icon = () => {
    return (
   
  <img src={ReportIcon} />


    )
  }
  export default Icon;